import { Ref, useState } from "react";
import { CreateOrderWizard } from "../helpers/createOrderHelpers";
import { MIME_TYPES } from "@mantine/dropzone";
import { useTranslation } from "react-i18next";
import Dropzone from "@/components/molecules/Dropzone";

interface Props {
  onValidationSuccess: () => void;
  onChangeWizardData: (data: any) => void;
  wizardData: CreateOrderWizard;
  ref?: Ref<HTMLFormElement>;
}

function Image({ onValidationSuccess, onChangeWizardData, ref }: Props) {
  const { t } = useTranslation();
  const [images, setImages] = useState<File[]>([]);

  const onSubmit = () => {
    onChangeWizardData({ images: images });
    onValidationSuccess();
  };

  return (
    <form ref={ref} onSubmit={onSubmit}>
      <Dropzone
        origin="local"
        type={"dropzone"}
        files={images}
        setFiles={setImages}
        buttonPosition="left"
        buttonLabel={t("claims:uploadImages")}
        accept={[MIME_TYPES.jpeg, MIME_TYPES.png]}
        showAsImageCarousel
        imageCarouselHeight={200}
      />
    </form>
  );
}

export default Image;
